import { render, staticRenderFns } from "./CoverageItem.vue?vue&type=template&id=2d5cd095&scoped=true"
import script from "./CoverageItem.vue?vue&type=script&lang=js"
export * from "./CoverageItem.vue?vue&type=script&lang=js"
import style0 from "./CoverageItem.vue?vue&type=style&index=0&id=2d5cd095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cd095",
  null
  
)

export default component.exports